import { matchPath } from 'react-router-dom';
import { useCartStore } from '@hungryroot/global-state';
import {
  EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE,
  EDIT_DELIVERY_GROCERIES_ROUTE,
  MY_HUNGRYROOT_ROUTE,
  ORDER_ROUTE,
} from '@hungryroot/routes';
import { GROCERIES_PAGE_NAME_MAPPINGS } from './pageNameMappings';

export const getGroceriesPageName = () => {
  const cartState = useCartStore.getState();
  if (cartState.cartActive) {
    return 'cart';
  }

  const url = new URL(window.location.href);
  const pathname = url.pathname;

  if (
    matchPath(pathname, {
      path: EDIT_DELIVERY_GROCERIES_FOR_YOU_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'for_you';
  }

  if (
    matchPath(pathname, {
      path: EDIT_DELIVERY_GROCERIES_ROUTE,
      exact: false,
      strict: false,
    }) &&
    url.searchParams.size === 0
  ) {
    return 'all';
  }

  if (
    matchPath(pathname, {
      path: MY_HUNGRYROOT_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'home';
  }

  if (
    matchPath(pathname, {
      path: ORDER_ROUTE,
      exact: false,
      strict: false,
    })
  ) {
    return 'order_details';
  }
  const match = Object.entries(GROCERIES_PAGE_NAME_MAPPINGS).find(([key]) =>
    url.searchParams.has(key)
  );

  return match?.[1];
};
